__turbopack_context__.v({
  "container": "hdakvq_container",
  "cta": "hdakvq_cta",
  "description": "hdakvq_description",
  "desktopChart": "hdakvq_desktopChart",
  "input": "hdakvq_input",
  "inputs": "hdakvq_inputs",
  "mobileChart": "hdakvq_mobileChart",
  "suggestedPercentages": "hdakvq_suggestedPercentages",
  "wrapper": "hdakvq_wrapper",
});
